import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ScatteredSection } from './components/ScatteredSection';
import { SystemSection } from './components/SystemSection';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { NotEbook } from './components/NotEbook';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PIXEL_ID } from './data/constants';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="6hpnd64cbd2">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="4wwnrzgd0hb" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-2" data-mp="33n6xd2hftr4b">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="38k6u2msedhir" />}
        <main data-id="element-4" data-mp="38nulngea7tuu">
          <Hero data-id="element-5" data-mp="3dkuwe4m2tksa" />
          <PainSection data-id="element-6" data-mp="3dle3eqa6uorj" />
          <ScatteredSection data-id="element-7" data-mp="3dlntedv8gvx8" />
          <SystemSection data-id="element-8" data-mp="3diruonbka37q" />
          <Modules data-id="element-9" data-mp="nvj1lae5u4n3" />
          <LookInside data-id="element-10" data-mp="nwc23tmizxws" />
          <Bonuses data-id="element-11" data-mp="nur8c681cizz" />
          <NotEbook data-id="element-12" data-mp="nvanjf6awtab" />
          <Offer data-id="element-13" data-mp="sunby4ctm8f0" />
          <Guarantee data-id="element-14" data-mp="su45bjsmf6ga" />
          <Testimonials data-id="element-15" data-mp="stkns46vuk2s" />
          <FAQ data-id="element-16" data-mp="sssqmoxn0eae" />
          <FinalCTA data-id="element-17" data-mp="swgkxqawp4q6" />
        </main>
        <Footer data-id="element-18" data-mp="35yngfn0fdzc" />
      </div>
    </>;
}
function initMetaPixel() {
  const pixelWindow = window as PixelWindow;
  try {
    if (!pixelWindow.fbq) {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue?.push(args);
        }
      }) as PixelFunction;
      pixelWindow.fbq = fbq;
      if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    pixelWindow.fbq?.('init', PIXEL_ID);
    pixelWindow.fbq?.('track', 'PageView');
  } catch (error) {
    console.warn('Meta Pixel init skipped:', error);
  }
}